export default __webpack_public_path__ + "static/max_pos_wonka_sweeps_form_top-bfe794ad4d1859d2e72693a2e0a7f7ee.jpg";